/* eslint-env browser, node */

'use strict';

module.exports = require('./lib');